import { render } from "./TopNavbar.vue?vue&type=template&id=10f0cad9"
import script from "./TopNavbar.vue?vue&type=script&lang=js"
export * from "./TopNavbar.vue?vue&type=script&lang=js"

import "./TopNavbar.vue?vue&type=style&index=0&id=10f0cad9&lang=scss"
script.render = render

export default script